import { postVenueSearch } from '../../../../../../ui-kitchen/src/api';
import { ISO_DATE_FORMAT, ALL_DAY } from '../../../../../../ui-kitchen/src/constants/resyCore';
import transformSlots from '../../../../../../ui-kitchen/src/transformers/transformSlots';
import transformVenues from '../../../../../../ui-kitchen/src/transformers/transformVenues';
import { Logger } from '../../../../../../ui-kitchen/src/utils';

const processVenueData = (data) => {
  if (!data) return null;

  const { hits } = data.search;
  return hits.reduce(
    (acc, venue) => {
      const restaurant = {
        venue: { ...venue },
      };

      acc.push({
        slots: transformSlots(restaurant.venue?.availability?.slots).map((item) => ({ ...item, tockBookingUrl: item.tockAmexMktBookingUrl })),
        venue: {
          ...transformVenues(restaurant),
          activeNotifications:
            restaurant.venue?.availability?.notifies.reduce((notifies, item) => {
              notifies[item.service_type_id] = item;
              return notifies;
            }, {}),
          location: {
            ...restaurant.venue?.location,
            urlSlug: restaurant.venue?.location?.url_slug,
            neighborhood: restaurant.venue?.location?.neighborhood || restaurant.venue?.location?.name,
          },
          availableServiceTypes: Object.keys(restaurant.venue?.availability?.service_types),
          rating: restaurant.venue?.rating?.average,
          cuisine: restaurant.venue?.cuisine,
          priceRange: restaurant.venue?.price_range_id,
          images: restaurant.venue?.images,
          responsiveImages: restaurant.venue?.images,
          experiences: restaurant.venue?.availability?.experiences,
          isTockInventory: restaurant.venue.is_tock_inventory,
          tockBusinessPageUrl: restaurant.venue.tock_business_page_url,
          tockBusinessSearchUrl: restaurant.venue.tock_business_search_url,
          tockNotifyUrl: restaurant.venue?.availability?.tock_notify_url,
        },
      });
      return acc;
    }, []
  );
};

const getSlotFilter = (date, partySize, time) => ({
  day: moment(date).format('YYYY-MM-DD'),
  party_size: +partySize,
  time_filter: time,
});

const getEligibleVenuesPayload = (params, { includeTockInventory = false } = {}) => {
  const payload = {
    availability: true,
    ...(includeTockInventory && { include_tock_inventory: true }),
    page: params.page,
    per_page: params.hitsPerPage,
    slot_filter: getSlotFilter(params.selectedDate, params.selectedPartySize, params.timeFilter),
    types: ['venue'],
    inventory: params.inventory,
    order_by: 'availability',
  };

  payload.geo = {
    latitude: params.latitude,
    longitude: params.longitude,
    radius: params.radius * 1610,
  };
  payload.venue_filter = { resy_credit_eligible_only: true };
  return payload;
};

export const getResyCreditEligibleVenues = async (selectedCoreSeats, selectedCoreISODate, selectedCoreTime, locationData, isJceBridgeEnabled) => {
  const params = {};
  params.selectedLocationCode = locationData?.code;
  params.hitsPerPage = 10;

  const { latitude, longitude, radius } = locationData;

  params.latitude = latitude;
  params.longitude = longitude;
  params.radius = radius;
  params.page = 1;
  params.selectedDate = moment(selectedCoreISODate, ISO_DATE_FORMAT).toDate();
  params.selectedPartySize = selectedCoreSeats;

  params.timeFilter = (selectedCoreTime === ALL_DAY || !selectedCoreTime) ? undefined
    : moment(selectedCoreTime, 'HHmm').format('HH:mm');

  const payload = getEligibleVenuesPayload(params, { includeTockInventory: isJceBridgeEnabled });
  try {
    const response = await postVenueSearch(payload);
    return processVenueData(response);
  } catch (error) {
    Logger.error('Error fetching eligible venues for Resy Credit', error);
  }
  return null;
};

export const getConvertedTextData = (cityName, text = '') => {
  const templateText = text || '';
  const updatedText = templateText.replace('{city_name}', cityName);
  return updatedText;
};

export default getResyCreditEligibleVenues;
